import { string, object, number, boolean, array } from 'yup';
const mappingSchema = object().shape({
    currencyCode: string().required().nonNullable(),
    stripePaymentsAccountExternalId: string().optional().nullable(),
});
export const stripeAccountSchema = object({
    stripeFeeAccountExternalId: string().nullable(),
    stripeContactId: number().nullable(),
    stripePaymentsAccountExternalId: string().nullable(),
    stripeSurchargesAccountExternalId: string().nullable(),
    surchargeEnabled: boolean().required(),
    surchargeFlatRateCents: number().required(),
    surchargePercentage: number().required(),
    paymentMappings: array().of(mappingSchema).required(),
});
//# sourceMappingURL=stripeAccount.js.map